<footer class="text-center small text-muted py-2">
  © {{ current_year }} Powered by <span class="fw-semibold">{{ powered_by_name }}</span>
</footer>